import React from "react";
import { Trans } from "react-i18next";

export const FooterLogin = () => (
    <div className="footer">
        <p>
            <Trans
                i18nKey="Footer.CopyRight"
                values={{ currentYear: new Date().getFullYear() }}
            />
        </p>
    </div>
);
